import {
  EntityTypeSupportingPinnedFields,
  FieldDescription,
} from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

// Looks a pinned field up by its stored name; injected so the build stays pure
export type ResolveField = (
  entityType: EntityTypeSupportingPinnedFields,
  fieldName: string
) => IField | undefined;

// Uses the field's current name, so a removed field's legacy name matches its replacement
const convertToFieldDescription =
  (resolveField: ResolveField, entityType: EntityTypeSupportingPinnedFields, startFrom: number) =>
  (field: FieldDescription | string, index: number): FieldDescription => {
    const description =
      typeof field === "string" ? { displayOrder: startFrom + index, fieldName: field } : field;
    const currentFieldName = resolveField(entityType, description.fieldName)?.name;
    return currentFieldName ? { ...description, fieldName: currentFieldName } : description;
  };

export default convertToFieldDescription;
